import { FaTimes } from "react-icons/fa";

const Terminal = ({ title, onClose, children }) => {
    return (
        <div className="w-full overflow-hidden rounded-xl border border-slate-300 bg-white shadow-2xl dark:border-white/10 dark:bg-slate-900">
            {/* Header */}
            <div className="relative flex items-center border-b border-slate-200 bg-slate-100 px-4 py-3 dark:border-white/10 dark:bg-slate-800">
                <div className="flex gap-2">
                    <span className="h-3 w-3 rounded-full bg-red-500/90" />
                    <span className="h-3 w-3 rounded-full bg-yellow-500/90" />
                    <span className="h-3 w-3 rounded-full bg-green-500/90" />
                </div>
                <span className="absolute left-1/2 -translate-x-1/2 font-mono text-xs text-slate-500 dark:text-slate-400">
                    {title}.py
                </span>
                {onClose && (
                    <button
                        type="button"
                        onClick={onClose}
                        aria-label="Stäng"
                        className="ml-auto rounded-md p-1 text-slate-500 transition-colors hover:bg-slate-200 hover:text-slate-900 dark:text-slate-400 dark:hover:bg-white/10 dark:hover:text-white"
                    >
                        <FaTimes size={14} />
                    </button>
                )}
            </div>

            {/* Code Area */}
            <div className="p-5 font-mono text-sm text-slate-900 dark:text-slate-100">
                {children}
            </div>
        </div>
    )
}


export default Terminal;
